import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface MiscellaneousSettingsTextDTO {
  singleSelectDropdownChooseOptionText: SurveyLocalizedTextDTO;
  mandatoryQuestionErrorText: SurveyLocalizedTextDTO;
  allGridRowsNotAnsweredErrorText: SurveyLocalizedTextDTO;
  allAttemptedGridRowsNotAnsweredErrorText: SurveyLocalizedTextDTO;
  allRankingOptionsMandatory: SurveyLocalizedTextDTO;
  singleSelectSliderTooltipText: SurveyLocalizedTextDTO;
  multiSelectAndRankingMaxSelectionText: SurveyLocalizedTextDTO;
  areAllRankingOptionsMandatoryText: SurveyLocalizedTextDTO;
  questionRequiredText: SurveyLocalizedTextDTO;
  chatOpenEndedShowMoreText: SurveyLocalizedTextDTO;
  chatOpenEndedShowLessText: SurveyLocalizedTextDTO;
  chatSkippedAnswerText: SurveyLocalizedTextDTO;
  chatGroupNextQuestionButtonText: SurveyLocalizedTextDTO;
  chatGroupSendResponseButtonText: SurveyLocalizedTextDTO;
  editAnswerButtonText: SurveyLocalizedTextDTO;
  editAnswersButtonText: SurveyLocalizedTextDTO;
  cancelEditAnswerButtonText: SurveyLocalizedTextDTO;
}

export class MiscellaneousSettingsText {
  readonly isMiscellaneousSettingsTextMiscellaneousSettingsText: boolean = true;

  readonly singleSelectDropdownChooseOptionText: SurveyLocalizedText;
  readonly mandatoryQuestionErrorText: SurveyLocalizedText;
  readonly allGridRowsNotAnsweredErrorText: SurveyLocalizedText;
  readonly allAttemptedGridRowsNotAnsweredErrorText: SurveyLocalizedText;
  readonly allRankingOptionsMandatory: SurveyLocalizedText;
  readonly singleSelectSliderTooltipText: SurveyLocalizedText;
  readonly multiSelectAndRankingMaxSelectionText: SurveyLocalizedText;
  readonly areAllRankingOptionsMandatoryText: SurveyLocalizedText;
  readonly questionRequiredText: SurveyLocalizedText;
  readonly chatOpenEndedShowMoreText: SurveyLocalizedText;
  readonly chatOpenEndedShowLessText: SurveyLocalizedText;
  readonly chatSkippedAnswerText: SurveyLocalizedText;
  readonly chatGroupNextQuestionButtonText: SurveyLocalizedText;
  readonly chatGroupSendResponseButtonText: SurveyLocalizedText;
  readonly editAnswerButtonText: SurveyLocalizedText;
  readonly editAnswersButtonText: SurveyLocalizedText;
  readonly cancelEditAnswerButtonText: SurveyLocalizedText;


  constructor(
  singleSelectDropdownChooseOptionText: SurveyLocalizedText, 
  mandatoryQuestionErrorText: SurveyLocalizedText, 
  allGridRowsNotAnsweredErrorText: SurveyLocalizedText, 
  allAttemptedGridRowsNotAnsweredErrorText: SurveyLocalizedText, 
  allRankingOptionsMandatory: SurveyLocalizedText, 
  singleSelectSliderTooltipText: SurveyLocalizedText, 
  multiSelectAndRankingMaxSelectionText: SurveyLocalizedText, 
  areAllRankingOptionsMandatoryText: SurveyLocalizedText, 
  questionRequiredText: SurveyLocalizedText, 
  chatOpenEndedShowMoreText: SurveyLocalizedText, 
  chatOpenEndedShowLessText: SurveyLocalizedText, 
  chatSkippedAnswerText: SurveyLocalizedText, 
  chatGroupNextQuestionButtonText: SurveyLocalizedText, 
  chatGroupSendResponseButtonText: SurveyLocalizedText, 
  editAnswerButtonText: SurveyLocalizedText, 
  editAnswersButtonText: SurveyLocalizedText, 
  cancelEditAnswerButtonText: SurveyLocalizedText
  ) {
    this.singleSelectDropdownChooseOptionText = singleSelectDropdownChooseOptionText;
    this.mandatoryQuestionErrorText = mandatoryQuestionErrorText;
    this.allGridRowsNotAnsweredErrorText = allGridRowsNotAnsweredErrorText;
    this.allAttemptedGridRowsNotAnsweredErrorText = allAttemptedGridRowsNotAnsweredErrorText;
    this.allRankingOptionsMandatory = allRankingOptionsMandatory;
    this.singleSelectSliderTooltipText = singleSelectSliderTooltipText;
    this.multiSelectAndRankingMaxSelectionText = multiSelectAndRankingMaxSelectionText;
    this.areAllRankingOptionsMandatoryText = areAllRankingOptionsMandatoryText;
    this.questionRequiredText = questionRequiredText;
    this.chatOpenEndedShowMoreText = chatOpenEndedShowMoreText;
    this.chatOpenEndedShowLessText = chatOpenEndedShowLessText;
    this.chatSkippedAnswerText = chatSkippedAnswerText;
    this.chatGroupNextQuestionButtonText = chatGroupNextQuestionButtonText;
    this.chatGroupSendResponseButtonText = chatGroupSendResponseButtonText;
    this.editAnswerButtonText = editAnswerButtonText;
    this.editAnswersButtonText = editAnswersButtonText;
    this.cancelEditAnswerButtonText = cancelEditAnswerButtonText;
  }

  static fromDTO(dto: MiscellaneousSettingsTextDTO): MiscellaneousSettingsText {
    const singleSelectDropdownChooseOptionText = SurveyLocalizedText.fromDTO(getObject(dto, "singleSelectDropdownChooseOptionText", InvalidMiscellaneousSettingsTextSingleSelectDropdownChooseOptionTextError));
    const mandatoryQuestionErrorText = SurveyLocalizedText.fromDTO(getObject(dto, "mandatoryQuestionErrorText", InvalidMiscellaneousSettingsTextMandatoryQuestionErrorTextError));
    const allGridRowsNotAnsweredErrorText = SurveyLocalizedText.fromDTO(getObject(dto, "allGridRowsNotAnsweredErrorText", InvalidMiscellaneousSettingsTextAllGridRowsNotAnsweredErrorTextError));
    const allAttemptedGridRowsNotAnsweredErrorText = SurveyLocalizedText.fromDTO(getObject(dto, "allAttemptedGridRowsNotAnsweredErrorText", InvalidMiscellaneousSettingsTextAllAttemptedGridRowsNotAnsweredErrorTextError));
    const allRankingOptionsMandatory = SurveyLocalizedText.fromDTO(getObject(dto, "allRankingOptionsMandatory", InvalidMiscellaneousSettingsTextAllRankingOptionsMandatoryError));
    const singleSelectSliderTooltipText = SurveyLocalizedText.fromDTO(getObject(dto, "singleSelectSliderTooltipText", InvalidMiscellaneousSettingsTextSingleSelectSliderTooltipTextError));
    const multiSelectAndRankingMaxSelectionText = SurveyLocalizedText.fromDTO(getObject(dto, "multiSelectAndRankingMaxSelectionText", InvalidMiscellaneousSettingsTextMultiSelectAndRankingMaxSelectionTextError));
    const areAllRankingOptionsMandatoryText = SurveyLocalizedText.fromDTO(getObject(dto, "areAllRankingOptionsMandatoryText", InvalidMiscellaneousSettingsTextAreAllRankingOptionsMandatoryTextError));
    const questionRequiredText = SurveyLocalizedText.fromDTO(getObject(dto, "questionRequiredText", InvalidMiscellaneousSettingsTextQuestionRequiredTextError));
    const chatOpenEndedShowMoreText = SurveyLocalizedText.fromDTO(getObject(dto, "chatOpenEndedShowMoreText", InvalidMiscellaneousSettingsTextChatOpenEndedShowMoreTextError));
    const chatOpenEndedShowLessText = SurveyLocalizedText.fromDTO(getObject(dto, "chatOpenEndedShowLessText", InvalidMiscellaneousSettingsTextChatOpenEndedShowLessTextError));
    const chatSkippedAnswerText = SurveyLocalizedText.fromDTO(getObject(dto, "chatSkippedAnswerText", InvalidMiscellaneousSettingsTextChatSkippedAnswerTextError));
    const chatGroupNextQuestionButtonText = SurveyLocalizedText.fromDTO(getObject(dto, "chatGroupNextQuestionButtonText", InvalidMiscellaneousSettingsTextChatGroupNextQuestionButtonTextError));
    const chatGroupSendResponseButtonText = SurveyLocalizedText.fromDTO(getObject(dto, "chatGroupSendResponseButtonText", InvalidMiscellaneousSettingsTextChatGroupSendResponseButtonTextError));
    const editAnswerButtonText = SurveyLocalizedText.fromDTO(getObject(dto, "editAnswerButtonText", InvalidMiscellaneousSettingsTextEditAnswerButtonTextError));
    const editAnswersButtonText = SurveyLocalizedText.fromDTO(getObject(dto, "editAnswersButtonText", InvalidMiscellaneousSettingsTextEditAnswersButtonTextError));
    const cancelEditAnswerButtonText = SurveyLocalizedText.fromDTO(getObject(dto, "cancelEditAnswerButtonText", InvalidMiscellaneousSettingsTextCancelEditAnswerButtonTextError));
    return new MiscellaneousSettingsText(
      singleSelectDropdownChooseOptionText,
      mandatoryQuestionErrorText,
      allGridRowsNotAnsweredErrorText,
      allAttemptedGridRowsNotAnsweredErrorText,
      allRankingOptionsMandatory,
      singleSelectSliderTooltipText,
      multiSelectAndRankingMaxSelectionText,
      areAllRankingOptionsMandatoryText,
      questionRequiredText,
      chatOpenEndedShowMoreText,
      chatOpenEndedShowLessText,
      chatSkippedAnswerText,
      chatGroupNextQuestionButtonText,
      chatGroupSendResponseButtonText,
      editAnswerButtonText,
      editAnswersButtonText,
      cancelEditAnswerButtonText
    );
  }

  toDTO(): MiscellaneousSettingsTextDTO {
    const dto: MiscellaneousSettingsTextDTO = {
        singleSelectDropdownChooseOptionText: this.singleSelectDropdownChooseOptionText.toDTO(),
        mandatoryQuestionErrorText: this.mandatoryQuestionErrorText.toDTO(),
        allGridRowsNotAnsweredErrorText: this.allGridRowsNotAnsweredErrorText.toDTO(),
        allAttemptedGridRowsNotAnsweredErrorText: this.allAttemptedGridRowsNotAnsweredErrorText.toDTO(),
        allRankingOptionsMandatory: this.allRankingOptionsMandatory.toDTO(),
        singleSelectSliderTooltipText: this.singleSelectSliderTooltipText.toDTO(),
        multiSelectAndRankingMaxSelectionText: this.multiSelectAndRankingMaxSelectionText.toDTO(),
        areAllRankingOptionsMandatoryText: this.areAllRankingOptionsMandatoryText.toDTO(),
        questionRequiredText: this.questionRequiredText.toDTO(),
        chatOpenEndedShowMoreText: this.chatOpenEndedShowMoreText.toDTO(),
        chatOpenEndedShowLessText: this.chatOpenEndedShowLessText.toDTO(),
        chatSkippedAnswerText: this.chatSkippedAnswerText.toDTO(),
        chatGroupNextQuestionButtonText: this.chatGroupNextQuestionButtonText.toDTO(),
        chatGroupSendResponseButtonText: this.chatGroupSendResponseButtonText.toDTO(),
        editAnswerButtonText: this.editAnswerButtonText.toDTO(),
        editAnswersButtonText: this.editAnswersButtonText.toDTO(),
        cancelEditAnswerButtonText: this.cancelEditAnswerButtonText.toDTO()
    };
    return dto;
  }
  }

MiscellaneousSettingsText.prototype.toString = function toString(): string {
  return `MiscellaneousSettingsText(singleSelectDropdownChooseOptionText='${this.singleSelectDropdownChooseOptionText}',mandatoryQuestionErrorText='${this.mandatoryQuestionErrorText}',allGridRowsNotAnsweredErrorText='${this.allGridRowsNotAnsweredErrorText}',allAttemptedGridRowsNotAnsweredErrorText='${this.allAttemptedGridRowsNotAnsweredErrorText}',allRankingOptionsMandatory='${this.allRankingOptionsMandatory}',singleSelectSliderTooltipText='${this.singleSelectSliderTooltipText}',multiSelectAndRankingMaxSelectionText='${this.multiSelectAndRankingMaxSelectionText}',areAllRankingOptionsMandatoryText='${this.areAllRankingOptionsMandatoryText}',questionRequiredText='${this.questionRequiredText}',chatOpenEndedShowMoreText='${this.chatOpenEndedShowMoreText}',chatOpenEndedShowLessText='${this.chatOpenEndedShowLessText}',chatSkippedAnswerText='${this.chatSkippedAnswerText}',chatGroupNextQuestionButtonText='${this.chatGroupNextQuestionButtonText}',chatGroupSendResponseButtonText='${this.chatGroupSendResponseButtonText}',editAnswerButtonText='${this.editAnswerButtonText}',editAnswersButtonText='${this.editAnswersButtonText}',cancelEditAnswerButtonText='${this.cancelEditAnswerButtonText}')`;
};

export class InvalidMiscellaneousSettingsTextError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextError";
  }
}
export class InvalidMiscellaneousSettingsTextSingleSelectDropdownChooseOptionTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextSingleSelectDropdownChooseOptionTextError";
  }
}

export class InvalidMiscellaneousSettingsTextMandatoryQuestionErrorTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextMandatoryQuestionErrorTextError";
  }
}

export class InvalidMiscellaneousSettingsTextAllGridRowsNotAnsweredErrorTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextAllGridRowsNotAnsweredErrorTextError";
  }
}

export class InvalidMiscellaneousSettingsTextAllAttemptedGridRowsNotAnsweredErrorTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextAllAttemptedGridRowsNotAnsweredErrorTextError";
  }
}

export class InvalidMiscellaneousSettingsTextAllRankingOptionsMandatoryError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextAllRankingOptionsMandatoryError";
  }
}

export class InvalidMiscellaneousSettingsTextSingleSelectSliderTooltipTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextSingleSelectSliderTooltipTextError";
  }
}

export class InvalidMiscellaneousSettingsTextMultiSelectAndRankingMaxSelectionTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextMultiSelectAndRankingMaxSelectionTextError";
  }
}

export class InvalidMiscellaneousSettingsTextAreAllRankingOptionsMandatoryTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextAreAllRankingOptionsMandatoryTextError";
  }
}

export class InvalidMiscellaneousSettingsTextQuestionRequiredTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextQuestionRequiredTextError";
  }
}

export class InvalidMiscellaneousSettingsTextChatOpenEndedShowMoreTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextChatOpenEndedShowMoreTextError";
  }
}

export class InvalidMiscellaneousSettingsTextChatOpenEndedShowLessTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextChatOpenEndedShowLessTextError";
  }
}

export class InvalidMiscellaneousSettingsTextChatSkippedAnswerTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextChatSkippedAnswerTextError";
  }
}

export class InvalidMiscellaneousSettingsTextChatGroupNextQuestionButtonTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextChatGroupNextQuestionButtonTextError";
  }
}

export class InvalidMiscellaneousSettingsTextChatGroupSendResponseButtonTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextChatGroupSendResponseButtonTextError";
  }
}

export class InvalidMiscellaneousSettingsTextEditAnswerButtonTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextEditAnswerButtonTextError";
  }
}

export class InvalidMiscellaneousSettingsTextEditAnswersButtonTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextEditAnswersButtonTextError";
  }
}

export class InvalidMiscellaneousSettingsTextCancelEditAnswerButtonTextError extends InvalidMiscellaneousSettingsTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMiscellaneousSettingsTextCancelEditAnswerButtonTextError";
  }
}
